import {
  DELIVERY_LIST_REQUEST,
  DELIVERY_LIST_SUCCESS,
  DELIVERY_LIST_FAIL,
  DELIVERY_LIST_SAVE_REQUEST,
  DELIVERY_LIST_SAVE_SUCCESS,
  DELIVERY_LIST_SAVE_FAIL,
  DELIVERY_LIST_SAVE_RESET,
} from 'redux/constants/data/deliveryConstants';

export const deliveryListReducer = (
  state = { deliveryList: [], loading: true },
  action,
) => {
  const { type, payload } = action;
  switch (type) {
    case DELIVERY_LIST_REQUEST:
      return { ...state, loading: true };
    case DELIVERY_LIST_SUCCESS:
      return { deliveryList: payload || [], loading: false };
    case DELIVERY_LIST_FAIL:
      return { deliveryList: [], error: payload, loading: false };
    default:
      return state;
  }
};

export const deliveryListSaveReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case DELIVERY_LIST_SAVE_REQUEST:
      return { loading: true };
    case DELIVERY_LIST_SAVE_SUCCESS:
      return { loading: false, success: true };
    case DELIVERY_LIST_SAVE_FAIL:
      return { error: payload, loading: false };
    case DELIVERY_LIST_SAVE_RESET:
      return { error: null, success: false };
    default:
      return state;
  }
};
